import * as React from 'react';
import CacheCrawlerQuery from '../../components/Query/CacheCrawler';
import { Button, Modal } from 'antd'

export default class CacheCrawler extends React.Component {
    public render() {
        return (
            <CacheCrawlerQuery>
                {({cacheCrawler,regeneratePageCache}) => {
                    if (cacheCrawler.loading || cacheCrawler.error) {
                        return null;
                    }
                    const stats = cacheCrawler.getCurrentState;
                    console.log('Cache stats', stats);
                    
                    return (
                        <div>
                            <div style={{height: '2em', display: 'inline-block'}} />
                            {/* Cache statistics:
                            waiting: {stats.countWaiting},
                            finished: {stats.countFinished},
                            needs recrawl: {stats.countNeedsRecrawl} */}
                            <Button
                                style={{ float: 'right' }}
                                onClick={() => {
                                    Modal.confirm({
                                        title: 'Refresh cache',
                                        content: <span>Are you sure to refresh cache?</span>,
                                        onOk: () => {
                                            regeneratePageCache()
                                                .then((result) => {
                                                    Modal.info({
                                                        title: 'Refresh cache',
                                                        content: result && result.data && result.data.regeneratePageCache
                                                            ? <div>
                                                                Generated {
                                                                    result.data.regeneratePageCache.urls
                                                                } urls for {
                                                                    result.data.regeneratePageCache.productCount
                                                                } products and {
                                                                    result.data.regeneratePageCache.categoryCount
                                                                } categories
                                                            </div>
                                                            : <span>Request to regenerate page cache sent</span>,
                                                    })
                                                })
                                                .catch((error) => Modal.error({
                                                    title: 'Refresh cache failed',
                                                    content: <span>{error}</span>,
                                                }));
                                        }
                                    })
                                }}
                            >
                                Refresh cache
                            </Button>
                        </div>
                    );
                }}
            </CacheCrawlerQuery>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CacheCrawler/CacheCrawler.tsx